<template>
  <div class="modal fade md-show" tabindex="-1" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <form @submit.prevent="submitForm">
          <div class="modal-body">
            <div id="registerClient-wrapper" class="card">
              <div class="title">Client Registration</div>
              <div class="form-wrapper">
                <div class="form-input">
                  <div class="subtitle">Provider Email:</div>
                  <input type="email" v-model="email" />
                </div>
                <div class="form-input">
                  <div class="subtitle">Client Name:</div>
                  <input type="text" v-model="name" />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="submit"
              class="btn btn-link btn-space btn-link-primary full"
              :disabled="loading"
            >
              <span v-if="!loading">{{ t("Add Client") }}</span>
              <span v-else>
                <i class="fad fa-circle-notch fa-spin"></i>
                Loading...
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
const serviceUrl = "https://api.maprinter.com/service";
export default {
  data() {
    return {
      loading: false,
      email: "",
      name: ""
    };
  },
  methods: {
    async submitForm() {
      this.loading = true;

      const formData = {
        providerEmail: this.email,
        clientName: this.name
      };
      const { providerEmail, clientName } = formData;

      try {
        const rawResponse = await fetch(
          `${serviceUrl}?request=addClientByProviderEmail&providerEmail=${providerEmail}&clientName=${clientName}`,
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ providerEmail, clientName })
          }
        );
        this.loading = false;

        const result = await rawResponse.json();
        const {
          body: { newUserId, error }
        } = result;

        const desktopDomain = location.host.startsWith("localhost")
          ? "localhost:9001"
          : "desktop.maprint.com";

        if (newUserId) {
          location.href = `http://${desktopDomain}/?user=${newUserId}`;
        } else if (error) {
          if (error === "clientAlreadyExists") {
            alert("Provider client name already exists");
          } else if (error === "providerNotFound") {
            alert("Provider email was not found");
          } else {
            alert("Error");
          }
        } else {
          alert("Error");
        }
      } catch (e) {
        alert("Error");
        console.log(e);
      }
    }
  }
};
</script>

<style lang="scss">
#app {
  #register-client {
    #registerClient-wrapper {
      margin: 0 auto;
      color: black;
      font-family: monospace;
      width: 100%;
      .top-registerClient {
        font-size: 2.33em;
        margin-bottom: 15px;
        letter-spacing: 1px;
        line-height: 30px;
      }
      .sub-registerClient {
        font-size: 2.56em;
        font-family: monospace;
        letter-spacing: 5px;
        span {
          text-transform: uppercase;
          color: #000000;
        }
      }
      #registerClient {
        width: 100%;
        canvas,
        img {
          width: 100%;
        }
      }
    }
    .modal-content {
      max-width: 20rem;
      margin: 0 auto;
      padding: 1.5rem;
      margin-top: 14vh;
      .modal-body {
        padding-top: unset;
        padding: 0;
        font-size: 1.4rem;
        .title {
          font-weight: bold;
        }
        .subtitle {
          font-size: 1.25rem;
        }
        .form-wrapper {
          padding: 1rem 0;
          .form-input {
            padding: 0.25rem;
            input {
              margin: 0.5rem 0;
              padding: 0.5rem;
              outline: none;
              font-size: 1.1rem;
              line-height: 1.1rem;
              min-width: 20rem;
              width: 100%;
            }
          }
        }
      }
      .modal-footer {
        justify-content: unset;
        padding: 0;
        .btn-link {
          margin: 0 auto;
          border: 1px solid;
          font-size: 14px;
          font-weight: bold;
          text-transform: capitalize;
          width: 100%;
        }
      }
    }
  }
  .hide {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RegisterClient.vue